export default __webpack_public_path__ + "static/faster-3d7baba05b8735b3cf02b255b62f8fc9.png";